<template>
    <ModalComponent
        :name="'cambiar-precio-' + abonado.id"
        :title="'Cambiar tipo de abono y precio de ' + abonado.name + ' ' + abonado.surnames"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
            <div class="row">
                <div class="col-12">
                    <span class="h3"><b>Información del abonado</b></span>
                </div>
                <div class="col-12">
                    <ul>
                        <li>
                            <b>Nº de abonado:</b> {{ abonado.n_abonado }}
                        </li>
                        <li>
                            <b>Nombre:</b> {{ abonado.name }}
                        </li>
                        <li>
                            <b>Apellidos:</b> {{ abonado.surnames }}
                        </li>
                        <li>
                            <b>Zona:</b> {{ abonado.asiento.region }}
                        </li>
                        <li>
                            <b>Fila:</b> {{ abonado.asiento.row }}
                        </li>
                        <li>
                            <b>Butaca:</b> {{ abonado.asiento.seat }}
                        </li>
                    </ul>
                </div>
                <div class="col-12 mt-3" v-if="! precio">
                    <div class="form-group">
                        <label for="area">Tipo de abono</label>
                        <ValidationProvider name="area" rules="required" v-slot="{ errors }">
                            <select name="area" v-model="tipo_abono" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" >
                                <template v-for="(precio, index) in tipos">
                                    <option :key="index" :value="precio">
                                        <span v-if="precio.renovacion">(Renovación) - </span>
                                        {{ precio.descripcion }}
                                    </option>
                                </template>
                            </select>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label for="precio">Precio</label>
                        <ValidationProvider name="precio" rules="required" v-slot="{ errors }">
                            <select name="precio" v-model="precio" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')">
                                <template v-for="(descuento, index) in precios_abono">
                                    <option :key="index" :value="descuento">
                                        {{ descuento.label_taquilla }}
                                    </option>
                                </template>
                            </select>
                        </ValidationProvider>
                    </div>
                </div>
                <div class="col-12 mt-3" v-if="precio">
                    <div class="row">
                        <div class="col-12">
                            <h2>
                                <span v-if="cambio > 0">
                                    Este cambio supone un ingreso de:
                                </span>
                                <span v-else>
                                    Este cambio supone una devolución:
                                </span>                         
                                {{ cambio | formatear_precio }}
                            </h2>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="metodo_pago">Método de pago/devolución</label>
                                <ValidationProvider name="método de pago" rules="required" v-slot="{ errors }">
                                    <select v-if="metodos_pago" name="metodo_pago" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" v-model="metodo_pago">
                                        <template v-for="(metodo, index) in metodos_pago">
                                            <option :key="index" :value="metodo.id">{{ metodo.nombre }}</option>
                                        </template>
                                    </select>
                                </ValidationProvider>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="col-12">
                    <Button type="submit" name="button" class="mr-3">CAMBIAR</Button>
                    <Button name="button" class="mr-3" @click="volver()">Cancelar</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
import ModalComponent from "@/components/backend/components/ModalComponent";

export default {
    props: ['abonado'],
    data() {
        return {
            tipos: [],
            loading: false,
            filters: {
                per_page: 999,
                page: 1,
                search: '',
                all: 1
            },
            tipo_abono: null,
            precio: null,
            metodo_pago: null,
            metodos_pago: null
        }
    },
    created() {
        this.getTipos();
        this.metodos_pago = this.teatro.metodos_pago_abonos_bases.slice();

        this.borrarMetodoDePago([5, 8, 9]);
    },
    computed: {
        precios_abono() {
            if(this.tipo_abono) {
                return this.tipo_abono.descuentos;
            } else {
                return [];
            }
        },
        cambio() {
            if(this.precio) {
                return this.precio.precio_total_taquilla - this.abonado.balance;
            }
                
            return 0;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        }
    },
    methods: {
        close(cambiado) {
            this.$emit('close', this.abonado.id, cambiado);
        },
        cambiar() {
            this.loading = true;

            const params = {
                id: this.abonado.id,
                abonado_id: this.abonado.id,
                descuento: this.precio,
                tipo_abono: this.tipo_abono,
                metodo_pago: this.metodo_pago
            }

            this.$store.dispatch(this.config.getVuexAlias('back.abonados.tipoabono.editar'), params).then(res => {
                this.close(true);
            }).finally(() => this.loading = false);
        },
        getTipos : function() {
            this.loading = true;
            const params = {
                filters : this.filters,
                lista_id: this.$store.getters.getListaId
            };

            this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                this.tipos = res.data.data;
                this.loading = false;
            });
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.cambiar();
            }
        },
        volver() {
            this.precio = null,
            this.tipo_abono = null;
            this.metodo_pago = null;
        },
        borrarMetodoDePago(idsAEliminar) {
            this.metodos_pago = this.metodos_pago.filter(metodo => !idsAEliminar.includes(metodo.id));
        }
    },
    components: {
        ModalComponent
    }
}
</script>
